import { useRef, useState } from 'react';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useMutation } from 'react-query';
import { Button } from 'primereact/button';

import { InputSwitch } from 'primereact/inputswitch';
import { sendMailFinishMembers } from 'apis/councils.api';
import Loading from 'components/Loading';
import ErrorDialog from 'components/ErrorDialog';

export default function ConfirmSendMailDialog({
  visible,
  setVisible,
  council,
  refetch,
  setIsSentMail,
}) {
  const { t } = useTranslation();

  const { projectProposalId } = useParams();
  const [isVisibleErrorDialog, setIsVisibleDialogError] = useState(false);
  const { mutate, error, isError, isLoading } = useMutation(sendMailFinishMembers);
  const toast = useRef(null);
  const [sentEmail, setSentEmail] = useState(true);

  const accept = () => {
    mutate(
      { projectProposalId, councilId: council?.id, isSentMail: sentEmail },
      {
        onSuccess: () => {
          toast.current.show({
            severity: 'success',
            summary: t(`council.member.confirm.success.${sentEmail ? 'doneAndSentEmail' : 'done'}`),
            life: 5000,
          });
          refetch();
          setIsSentMail(true);
        },
        onError: () => {
          setIsVisibleDialogError(true);
        },
      }
    );
    setVisible(false);
  };

  const handleCheckboxChange = (e) => {
    setSentEmail(e.value);
  };

  const message = (
    <div>
      <p>{t('council.createForManyProjectProposal.confirm.message')}</p>
      <div className="flex items-center justify-center gap-2">
        <InputSwitch checked={sentEmail} onChange={handleCheckboxChange} />
        <span className="font-bold line-height-3">
          {t('council.createForManyProjectProposal.confirm.mailToggle')}
        </span>
      </div>
    </div>
  );

  const footer = (
    <div>
      <Button
        label={t('formLayout.action.confirm')}
        icon="pi pi-check"
        onClick={accept}
        autoFocus
      />
    </div>
  );

  return (
    <>
      {isLoading && <Loading />}
      {isError && (
        <ErrorDialog
          title={t('council.member.confirm.titleDoneAndSendMailError')}
          isError={isError}
          error={error}
          visible={isVisibleErrorDialog}
          setVisible={setIsVisibleDialogError}
        />
      )}
      <Toast ref={toast} />
      <ConfirmDialog
        draggable={false}
        visible={visible}
        className="p-text-center w-4"
        onHide={() => setVisible(false)}
        message={message}
        header={t('council.member.confirm.header')}
        footer={footer}
      />
    </>
  );
}

ConfirmSendMailDialog.propTypes = {
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  council: PropTypes.object,
  refetch: PropTypes.func,
  setIsSentMail: PropTypes.func,
};

ConfirmSendMailDialog.defaultProps = {
  council: {},
  refetch: () => {},
  setIsSentMail: () => {},
};
